var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStandingDesks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.8422,
    height: 1.72824,
    rx: 0.864118,
    fill: "#AAB2B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5918,
    y: 13.2498,
    width: 13.2498,
    height: 1.4402,
    rx: 0.720098,
    fill: "#AAB2B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.68066,
    y: 14.0146,
    width: 8.14687,
    height: 1.01966,
    rx: 0.509829,
    transform: "rotate(-54.0097 3.68066 14.0146)",
    fill: "#AAB2B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0049,
    y: 14.4075,
    width: 8.14687,
    height: 1.01966,
    rx: 0.509829,
    transform: "rotate(-127.01 14.0049 14.4075)",
    fill: "#AAB2B1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20215,
    y: 7.69763,
    width: 8.14687,
    height: 1.01966,
    rx: 0.509829,
    transform: "rotate(-122.01 9.20215 7.69763)",
    fill: "#AAB2B1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5078,
    y: 0.746094,
    width: 8.14687,
    height: 1.01966,
    rx: 0.509829,
    transform: "rotate(120.99 13.5078 0.746094)",
    fill: "#AAB2B1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36058,
    cy: 7.34496,
    r: 1.58422,
    fill: "#AAB2B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandingDesks);
export default __webpack_public_path__ + "static/media/standing_desks.7b6dc3e0338220303a18c510564c5798.svg";
export { ForwardRef as ReactComponent };